import type { IconSvgObject } from './types';

const Menu09Icon: IconSvgObject = [
  ["path", { d: "M4 8.5L20 8.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 15.5L20 15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Menu09Icon;
